import { render, staticRenderFns } from "./Alien.vue?vue&type=template&id=f585be48&scoped=true&"
import script from "./Alien.vue?vue&type=script&lang=ts&"
export * from "./Alien.vue?vue&type=script&lang=ts&"
import style0 from "./Alien.vue?vue&type=style&index=0&id=f585be48&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f585be48",
  null
  
)

export default component.exports